// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gq-3";
export var downloadButton = "_gq-4";
export var fileContainer = "_gq-9 _gq-7";
export var fileContainerBase = "_gq-7";
export var fileContainerFixedHeight = "_gq-8 _gq-7";
export var fileInfo = "_gq-5";
export var fileInfoWidthRestricted = "_gq-6";
export var fileType = "_gq-1";
export var fileTypeName = "_gq-2";
export var image = "_gq-0";
export var link = "_gq-b";
export var overflowEllipsis = "_gq-a";